const RightPanel = () => import('@/components/RightPanel.vue');// 右滑详情页面

const TransactionDetail = () => import('@/pages/transaction/TransactionDetail.vue');
const TransactionManage = () => import('@/pages/transaction/TransactionManage.vue');

const RransactionRouter = [
	{
		path: '/TransactionManage',
		name: 'TransactionManage',
		component: TransactionManage,
		children: [
			{
				path: '/TransactionRightPanel',
				name: 'TransactionRightPanel',
				meta: { parent: '/TransactionManage' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/TransactionDetail/:subParams',
						name: 'TransactionDetail',
						meta: { parent: '/TransactionManage' },
						component: TransactionDetail,
					},
				],
			},
		],
	},
];

export default RransactionRouter;
